import { createContext } from "react";

/**
 * @typedef {object} GameCtxShape
 * @property {string} [gameRoom]
 * @property {string} [id]
 * @property {string} [playerAlias]
 * @property {boolean} [isHost]
 * @property {any} [myState]
 * @property {any} [publicStates]
 * @property {any} [roomJdata]
 * @property {any} [settings]
 * @property {any[]} gqActionsHistA
 * @property {number} [applyToIdx]
 * @property {number} nonBlankStacksCount
 * @property {boolean} [isGeneratingAiDrawings]
 * @property {string} [justFinishedGameId]
 * @property {boolean} [isKickingPlayer]
 * @property {(isKicking: boolean) => void} setIsKickingPlayer
 * @property {() => Promise<void>} [fetchGameUpdate]
 */

export const GameContext = createContext(/** @type {GameCtxShape} */ ({}))
